module.exports = __webpack_public_path__ + "static/media/futureskill1.dbec5e5f.png";